// // src/components/checkout/LocationSection.jsx
// import { useRef, useState } from "react";
// import { GoogleMap, Marker, Autocomplete, useJsApiLoader } from "@react-google-maps/api";
// import { MapPinIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

// const LIBRARIES = ["places"];
// const MAP_STYLE = { width: "100%", height: "280px" };
// const DEFAULT_CENTER = { lat: 18.5204, lng: 73.8567 }; // Pune

// export default function LocationSection({
//   userLocation,
//   setUserLocation,
//   address,
//   setAddress,
//   locationError,
//   setLocationError,
// }) {
//   const autocompleteRef = useRef(null);
//   const [gpsLoading, setGpsLoading] = useState(false);

//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "",
//     libraries: LIBRARIES,
//   });

//   // ── 1. GPS current location ───────────────────────────────────────────
//   const handleCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       setLocationError("Geolocation is not supported by your browser.");
//       return;
//     }
//     setGpsLoading(true);
//     setLocationError("");
//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude });
//         setGpsLoading(false);
//       },
//       () => {
//         setLocationError("Could not get location. Please allow location access or search manually.");
//         setGpsLoading(false);
//       },
//       { enableHighAccuracy: true, timeout: 12000 }
//     );
//   };

//   // ── 2. Autocomplete search place selected ────────────────────────────
//   const handlePlaceChanged = () => {
//     const place = autocompleteRef.current?.getPlace();
//     if (!place?.geometry) return;

//     const lat = place.geometry.location.lat();
//     const lng = place.geometry.location.lng();
//     setUserLocation({ lat, lng });
//     setLocationError("");

//     // Auto-fill address fields from Google place result
//     const comp = place.address_components || [];
//     const get = (type) => comp.find((c) => c.types.includes(type))?.long_name || "";

//     setAddress((prev) => ({
//       ...prev,
//       area:        get("sublocality_level_1") || get("sublocality") || get("route") || prev.area,
//       city:        get("locality") || get("administrative_area_level_2") || prev.city,
//       pincode:     get("postal_code") || prev.pincode,
//       landmark:    place.name || prev.landmark,
//       fullAddress: place.formatted_address || prev.fullAddress,
//     }));
//   };

//   // ── 3. Map click or marker drag ──────────────────────────────────────
//   const handleMapClick = (e) => {
//     setUserLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });
//     setLocationError("");
//   };

//   const mapCenter =
//     userLocation.lat && userLocation.lng
//       ? { lat: Number(userLocation.lat), lng: Number(userLocation.lng) }
//       : DEFAULT_CENTER;

//   const hasLocation = !!(userLocation.lat && userLocation.lng);

//   return (
//     <div className="space-y-4">
//       {/* Section heading */}
//       <div className="flex items-center gap-2">
//         <div className="w-7 h-7 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
//           <MapPinIcon className="h-4 w-4 text-indigo-600" />
//         </div>
//         <div>
//           <p className="text-sm font-bold text-gray-900">Your Location</p>
//           <p className="text-xs text-gray-500">Required for finding nearest service center</p>
//         </div>
//       </div>

//       {/* GPS Button */}
//       <button
//         type="button"
//         onClick={handleCurrentLocation}
//         disabled={gpsLoading}
//         className={[
//           "w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl border-2 text-sm font-semibold transition-all",
//           hasLocation
//             ? "border-green-500 bg-green-50 text-green-700"
//             : "border-indigo-400 bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
//           gpsLoading ? "opacity-60 cursor-not-allowed" : "",
//         ].join(" ")}
//       >
//         {gpsLoading ? (
//           <>
//             <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
//               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
//             </svg>
//             Getting your location…
//           </>
//         ) : hasLocation ? (
//           <>✅ Location Set — Click to Update</>
//         ) : (
//           <>
//             <MapPinIcon className="h-4 w-4" />
//             Use My Current Location
//           </>
//         )}
//       </button>

//       {/* Search Box */}
//       {isLoaded ? (
//         <Autocomplete
//           onLoad={(ref) => (autocompleteRef.current = ref)}
//           onPlaceChanged={handlePlaceChanged}
//           options={{ componentRestrictions: { country: "in" } }}
//         >
//           <div className="relative">
//             <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search address, area or landmark…"
//               className="w-full pl-9 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
//             />
//           </div>
//         </Autocomplete>
//       ) : (
//         <div className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-400 bg-gray-50">
//           Loading search…
//         </div>
//       )}

//       {/* Error */}
//       {locationError && (
//         <p className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
//           ⚠️ {locationError}
//         </p>
//       )}

//       {/* Map */}
//       {isLoaded ? (
//         <div className="rounded-xl overflow-hidden border-2 border-gray-200">
//           <GoogleMap
//             mapContainerStyle={MAP_STYLE}
//             center={mapCenter}
//             zoom={hasLocation ? 15 : 12}
//             onClick={handleMapClick}
//             options={{ disableDefaultUI: false, zoomControl: true, streetViewControl: false }}
//           >
//             {hasLocation && (
//               <Marker
//                 position={mapCenter}
//                 draggable
//                 onDragEnd={(e) =>
//                   setUserLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() })
//                 }
//               />
//             )}
//           </GoogleMap>
//         </div>
//       ) : (
//         <div className="h-[280px] rounded-xl bg-gray-100 flex items-center justify-center text-sm text-gray-400 border-2 border-gray-200">
//           Loading map…
//         </div>
//       )}

//       {/* Coordinates badge */}
//       {hasLocation && (
//         <div className="flex items-center gap-2 text-xs text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2">
//           <span>📍</span>
//           <span>
//             {Number(userLocation.lat).toFixed(6)}, {Number(userLocation.lng).toFixed(6)}
//           </span>
//         </div>
//       )}

//       {/* Address Fields — required for BOTH center & doorstep */}
//       <div className="space-y-3 pt-1">
//         <p className="text-xs font-bold text-gray-700 uppercase tracking-wide">
//           Complete Address <span className="text-red-500">*</span>
//         </p>

//         {/* Row 1: Flat + Area */}
//         <div className="grid grid-cols-2 gap-3">
//           <div>
//             <input
//               type="text"
//               placeholder="Flat / House No *"
//               value={address.flatNo}
//               onChange={(e) => setAddress((p) => ({ ...p, flatNo: e.target.value }))}
//               className={inputClass(!address.flatNo.trim())}
//             />
//           </div>
//           <div>
//             <input
//               type="text"
//               placeholder="Area / Locality *"
//               value={address.area}
//               onChange={(e) => setAddress((p) => ({ ...p, area: e.target.value }))}
//               className={inputClass(!address.area.trim())}
//             />
//           </div>
//         </div>

//         {/* Landmark */}
//         <input
//           type="text"
//           placeholder="Landmark (Optional)"
//           value={address.landmark}
//           onChange={(e) => setAddress((p) => ({ ...p, landmark: e.target.value }))}
//           className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none text-sm transition-all"
//         />

//         {/* Row 2: City + Pincode */}
//         <div className="grid grid-cols-2 gap-3">
//           <input
//             type="text"
//             placeholder="City *"
//             value={address.city}
//             onChange={(e) => setAddress((p) => ({ ...p, city: e.target.value }))}
//             className={inputClass(!address.city.trim())}
//           />
//           <input
//             type="text"
//             placeholder="Pincode *"
//             value={address.pincode}
//             maxLength={6}
//             onChange={(e) =>
//               setAddress((p) => ({ ...p, pincode: e.target.value.replace(/\D/g, "").slice(0, 6) }))
//             }
//             className={inputClass(address.pincode.length > 0 && address.pincode.length < 6)}
//           />
//         </div>

//         {/* Full address textarea */}
//         <textarea
//           rows={2}
//           placeholder="Full Address *"
//           value={address.fullAddress}
//           onChange={(e) => setAddress((p) => ({ ...p, fullAddress: e.target.value }))}
//           className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none text-sm transition-all resize-none"
//         />
//       </div>
//     </div>
//   );
// }

// // helper: red border if invalid, else normal
// function inputClass(isInvalid) {
//   return [
//     "w-full px-3 py-2.5 border-2 rounded-xl focus:outline-none focus:ring-2 text-sm transition-all",
//     isInvalid
//       ? "border-red-300 focus:border-red-500 focus:ring-red-200"
//       : "border-gray-200 focus:border-indigo-600 focus:ring-indigo-200",
//   ].join(" ");
// }


// src/components/servicing/checkout/LocationSection.jsx
import React, { useCallback, useRef, useState } from 'react';
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
} from '@react-google-maps/api';
import {
  MapPinIcon,
  BuildingStorefrontIcon,
  TruckIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const LIBRARIES = ['places'];
const MAP_STYLE = { width: '100%', height: '280px', borderRadius: '12px' };
const INDIA_DEFAULT = { lat: 18.5204, lng: 73.8567 };

/**
 * LocationSection
 *
 * Props:
 *  serviceMode       'center' | 'doorstep'
 *  setServiceMode    fn
 *  userLocation      { lat, lng }
 *  setUserLocation   fn
 *  address           { flatNo, area, landmark, city, pincode, fullAddress }
 *  setAddress        fn
 *  locationError     string
 *  setLocationError  fn
 */
const LocationSection = ({
  serviceMode,
  setServiceMode,
  userLocation,
  setUserLocation,
  address,
  setAddress,
  locationError,
  setLocationError,
}) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
    libraries: LIBRARIES,
  });

  const [mapCenter, setMapCenter] = useState(INDIA_DEFAULT);
  const [markerPos, setMarkerPos] = useState(null);
  const [gpsLoading, setGpsLoading] = useState(false);
  const autocompleteRef = useRef(null);

  const isDoorstep = serviceMode === 'doorstep';

  // ── Helpers ──────────────────────────────────────────────────────────────
  const applyCoords = useCallback(
    (lat, lng) => {
      const coords = { lat, lng };
      setMapCenter(coords);
      setMarkerPos(coords);
      setUserLocation(coords);
      setLocationError('');
    },
    [setUserLocation, setLocationError]
  );

  const handleAddressField = (key, value) =>
    setAddress((prev) => ({ ...prev, [key]: value }));

  // ── GPS ───────────────────────────────────────────────────────────────────
  const handleGPS = useCallback(() => {
    if (!navigator.geolocation) {
      setLocationError('Geolocation is not supported by your browser.');
      return;
    }
    setGpsLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        applyCoords(pos.coords.latitude, pos.coords.longitude);
        setGpsLoading(false);
      },
      () => {
        setLocationError(
          'Unable to access location. Please allow permission or search manually.'
        );
        setGpsLoading(false);
      },
      { enableHighAccuracy: true, timeout: 12000 }
    );
  }, [applyCoords, setLocationError]);

  // ── Map click ─────────────────────────────────────────────────────────────
  const handleMapClick = useCallback(
    (e) => applyCoords(e.latLng.lat(), e.latLng.lng()),
    [applyCoords]
  );

  // ── Autocomplete place selected ───────────────────────────────────────────
  const handlePlaceChanged = useCallback(() => {
    const place = autocompleteRef.current?.getPlace();
    if (!place?.geometry) return;

    applyCoords(
      place.geometry.location.lat(),
      place.geometry.location.lng()
    );

    // Auto-fill address fields from Google place components
    const comps = place.address_components || [];
    const get = (type) =>
      comps.find((c) => c.types.includes(type))?.long_name || '';

    setAddress((prev) => ({
      ...prev,
      area:
        prev.area ||
        get('sublocality_level_1') ||
        get('sublocality') ||
        get('locality'),
      city:
        prev.city ||
        get('administrative_area_level_2') ||
        get('locality'),
      pincode: prev.pincode || get('postal_code'),
      landmark: prev.landmark || place.name || '',
      fullAddress:
        prev.fullAddress || place.formatted_address || '',
    }));
  }, [applyCoords, setAddress]);

  // ── Marker drag end ───────────────────────────────────────────────────────
  const handleMarkerDrag = useCallback(
    (e) => applyCoords(e.latLng.lat(), e.latLng.lng()),
    [applyCoords]
  );

  // ── Label text changes by service mode ───────────────────────────────────
  const locationLabel = isDoorstep
    ? '📍 Pickup Address — mechanic will come here'
    : '📍 Your Location — to find the nearest service center';

  const locationHint = isDoorstep
    ? 'Pin your exact address so our mechanic can reach you.'
    : 'We use this to match you with the closest available store.';

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-200 space-y-5">
      {/* ── Header ── */}
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <MapPinIcon className="h-5 w-5 text-indigo-600" />
        </div>
        <div>
          <h2 className="text-base sm:text-lg font-bold text-gray-900">
            Service Location
          </h2>
          <p className="text-xs text-gray-500">Choose how you want service</p>
        </div>
      </div>

      {/* ── Service Type Toggle ── */}
      <div className="grid grid-cols-2 gap-3">
        {[
          {
            key: 'center',
            icon: <BuildingStorefrontIcon className="h-5 w-5 text-white" />,
            title: 'Visit Service Center',
            desc: 'Drop your bike at store',
          },
          {
            key: 'doorstep',
            icon: <TruckIcon className="h-5 w-5 text-white" />,
            title: 'Doorstep Service',
            desc: 'Mechanic comes to you (+₹100)',
          },
        ].map(({ key, icon, title, desc }) => (
          <button
            key={key}
            type="button"
            onClick={() => setServiceMode(key)}
            className={[
              'relative p-3 sm:p-4 rounded-xl border-2 text-left transition-all duration-200',
              serviceMode === key
                ? 'border-indigo-600 bg-gradient-to-br from-indigo-50 to-purple-50 shadow-md'
                : 'border-gray-200 bg-white hover:border-indigo-300',
            ].join(' ')}
          >
            {serviceMode === key && (
              <CheckCircleIcon className="absolute top-2 right-2 h-5 w-5 text-indigo-600" />
            )}
            <div className="flex items-center gap-2 mb-1">
              <div className="w-9 h-9 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
                {icon}
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900 leading-tight">{title}</p>
                <p className="text-xs text-gray-500">{desc}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* ── Context Label ── */}
      <div className="px-4 py-3 bg-indigo-50 rounded-xl border border-indigo-100 text-sm text-indigo-700 font-medium">
        {locationLabel}
        <p className="text-xs font-normal text-indigo-500 mt-0.5">{locationHint}</p>
      </div>

      {/* ── Map Block ── */}
      {loadError ? (
        <div className="p-4 bg-red-50 rounded-xl border border-red-200 text-sm text-red-700">
          ⚠️ Google Maps failed to load. Check your API key.
        </div>
      ) : !isLoaded ? (
        <div className="h-40 bg-gray-100 rounded-xl flex items-center justify-center text-gray-400 text-sm animate-pulse">
          Loading map…
        </div>
      ) : (
        <div className="space-y-3">
          {/* Autocomplete search */}
          <Autocomplete
            onLoad={(ref) => (autocompleteRef.current = ref)}
            onPlaceChanged={handlePlaceChanged}
            options={{ componentRestrictions: { country: 'in' } }}
          >
            <input
              type="text"
              placeholder="🔍 Search your area, street or landmark…"
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </Autocomplete>

          {/* GPS button */}
          <button
            type="button"
            onClick={handleGPS}
            disabled={gpsLoading}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-all flex items-center justify-center gap-2"
          >
            {gpsLoading ? (
              <>
                <span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full" />
                Getting your location…
              </>
            ) : (
              <>
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z"/>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                Use My Current Location
              </>
            )}
          </button>

          {/* Google Map */}
          <GoogleMap
            mapContainerStyle={MAP_STYLE}
            center={mapCenter}
            zoom={15}
            onClick={handleMapClick}
            options={{ disableDefaultUI: false, zoomControl: true, streetViewControl: false }}
          >
            {markerPos && (
              <Marker
                position={markerPos}
                draggable
                onDragEnd={handleMarkerDrag}
                title="Drag to adjust"
              />
            )}
          </GoogleMap>

          <p className="text-xs text-gray-400 text-center">
            Click on the map or drag the pin to set your exact location.
          </p>

          {/* Coordinates confirmation badge */}
          {userLocation?.lat && userLocation?.lng && (
            <div className="flex items-center gap-2 px-3 py-2 bg-green-50 rounded-xl border border-green-200 text-xs text-green-700 font-medium">
              <CheckCircleIcon className="h-4 w-4 flex-shrink-0" />
              Location set: {Number(userLocation.lat).toFixed(5)},{' '}
              {Number(userLocation.lng).toFixed(5)}
            </div>
          )}

          {/* Error message */}
          {locationError && (
            <div className="flex items-center gap-2 px-3 py-2 bg-red-50 rounded-xl border border-red-200 text-xs text-red-700">
              ⚠️ {locationError}
            </div>
          )}
        </div>
      )}

      {/* ── Address Fields (shown for BOTH modes, required for doorstep) ── */}
      <div className="space-y-3 pt-2 border-t border-gray-100">
        <h3 className="text-sm font-bold text-gray-800">
          {isDoorstep ? 'Pickup Address Details' : 'Address Details (optional for center visits)'}
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Flat / House No {isDoorstep && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              placeholder="e.g., Flat 101, Tower A"
              value={address.flatNo}
              onChange={(e) => handleAddressField('flatNo', e.target.value)}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Area / Locality {isDoorstep && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              placeholder="e.g., Koregaon Park"
              value={address.area}
              onChange={(e) => handleAddressField('area', e.target.value)}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Landmark
            </label>
            <input
              type="text"
              placeholder="e.g., Near City Mall"
              value={address.landmark}
              onChange={(e) => handleAddressField('landmark', e.target.value)}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              City {isDoorstep && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              placeholder="e.g., Pune"
              value={address.city}
              onChange={(e) => handleAddressField('city', e.target.value)}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Pincode {isDoorstep && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              placeholder="6-digit pincode"
              value={address.pincode}
              onChange={(e) =>
                handleAddressField('pincode', e.target.value.replace(/\D/g, '').slice(0, 6))
              }
              maxLength={6}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Full Address {isDoorstep && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              placeholder="Complete address"
              value={address.fullAddress}
              onChange={(e) => handleAddressField('fullAddress', e.target.value)}
              className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200 transition-all text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSection;